// extracted by mini-css-extract-plugin
export default {"container":"NoPrize_container--dAK","title":"NoPrize_title--f5d","description":"NoPrize_description--gO8","imageWrapper":"NoPrize_imageWrapper--LyS","image":"NoPrize_image--wuG"};